import { Navigate } from "react-router";
import { toast } from "react-toastify";
import { useEffect } from "react";

export default function NotFoundRedirect() {
	useEffect(() => {
		toast.info("Page not found. Redirected to homepage.");
	}, []);

	return <Navigate to="/" replace />;
}
